<div
  [class]="'hx-tooltip hx-tooltip--position-' + position() + ' hx-tooltip--color-' + variant()"
  role="tooltip"
  [attr.id]="id()">
  <div class="hx-tooltip__content">
    @if (contentTemplate()) {
      <ng-container [ngTemplateOutlet]="contentTemplate()" [ngTemplateOutletContext]="contentTemplateContext() || {}" />
    } @else {
      {{ content() }}
    }
  </div>
  <div [class]="'hx-tooltip__arrow ' + arrowClass"></div>
</div>
